<template>
  <header>
    <nav :class="{ [$style.header_nav]: true, [$style.open]: open }">
      <div :class="$style.home_nav_img">
        <router-link :id="$style.home_nav" to="/"></router-link>
      </div>
      <button :class="$style.hamburger" @click="navOpen">
        <span :class="$style.line"></span>
        <span :class="$style.line"></span>
        <span :class="$style.line"></span>
      </button>
      <div :id="$style.nav_list">
        <ul v-show="!more | !getWindowSize">
          <router-link
            tag="li"
            :id="$style.about_nav"
            to="/about/1"
            :class="{ [$style.open_about]: more }"
            @click.native="navOpen"
          >
            <a>
              <span>
                <b>ミュージアムについて</b>
                <small>About</small>
              </span>
            </a>
          </router-link>
          <router-link tag="li" :id="$style.info_nav" to="/info" @click.native="navOpen">
            <a>
              <span>
                <b>施設情報</b>
                <small>Info</small>
              </span>
            </a>
          </router-link>
          <router-link
            tag="li"
            :id="$style.lookme_nav"
            to="/lookme"
            @click.native="navOpen"
          >
            <a>
              <span>
                <b>ルックミー</b>
                <small>LookMe</small>
              </span>
            </a>
          </router-link>
          <router-link
            tag="li"
            :id="$style.customer_nav"
            to="/customer"
            @click.native="navOpen"
          >
            <a>
              <span>
                <b>お客様のお声</b>
                <small>CustomerVoice</small>
              </span>
            </a>
          </router-link>
          <router-link
            tag="li"
            :id="$style.dreampost_nav"
            to="/dreampost"
            @click.native="navOpen"
          >
            <a>
              <span>
                <b>夢郵便</b>
                <small>DreamPost</small>
              </span>
            </a>
          </router-link>
          <router-link
            tag="li"
            :id="$style.hideki_nav"
            to="/hidekiinfo"
            @click.native="navOpen"
          >
            <a>
              <span>
                <b>松井秀喜情報</b>
                <small>HidekiMatsui</small>
              </span>
            </a>
          </router-link>
          <router-link tag="li" :id="$style.shop_nav" to="/shop" @click.native="navOpen">
            <a>
              <span>
                <b>ショップ</b>
                <small>Shop</small>
              </span>
            </a>
          </router-link>
        </ul>
        <!-- <div :id="$style.lang_nav">
          <span>
            <p :class="$style.lang_title">Language</p>
            <div>
              <p>Ja</p>
              <p :id="$style.slash">/</p>
              <p>En</p>
            </div>
          </span>
        </div>-->
        <div :id="$style.twitter_nav">
          <a href="https://twitter.com/Matsui_museum">
            <img src="@/assets/logo-white.png" />
          </a>
        </div>
        <div :class="$style.more_nav" v-show="more | !getWindowSize">
          <ul>
            <router-link tag="li" to="/saying" @click.native="navOpen">
              <a>
                <span>
                  <b>松井秀喜の言葉</b>
                  <small>Saying</small>
                </span>
              </a>
            </router-link>
            <router-link tag="li" to="/history" @click.native="navOpen">
              <a>
                <span>
                  <b>この日この時</b>
                  <small>History</small>
                </span>
              </a>
            </router-link>
            <router-link tag="li" to="/hrcard" @click.native="navOpen">
              <a>
                <span>
                  <b>ホームランカード</b>
                  <small>HomeRunCard</small>
                </span>
              </a>
            </router-link>
            <router-link tag="li" to="/movie" @click.native="navOpen">
              <a>
                <span>
                  <b>館内の上映動画</b>
                  <small>Movie</small>
                </span>
              </a>
            </router-link>
            <router-link tag="li" to="/exhibit" @click.native="navOpen">
              <a>
                <span>
                  <b>展示場のご案内</b>
                  <small>Exhibit</small>
                </span>
              </a>
            </router-link>
            <li :class="$style.padding"></li>
          </ul>
        </div>
        <div
          :class="{ [$style.more_btn]: true, [$style.open_more_btn]: more }"
          @click="moreClick"
        >
          <div :class="{ [$style.arrow_down]: !more, [$style.arrow_up]: more }"></div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "Header",
  data() {
    return {
      open: false,
      more: false,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.$store.commit("handleResize"));
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    getWindowSize() {
      // return this.$store.state.width < 1023;
      return this.width <= 1023;
    },
  },
  methods: {
    navOpen() {
      this.open = !this.open;
    },
    moreClick() {
      this.more = !this.more;
    },
    handleResize: function () {
      // resizeのたびにこいつが発火するので、ここでやりたいことをやる
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
  },
});
</script>

<style lang="scss" module>
// SP
@media only screen and (max-width: 1023px) {
  $font_size: 15px;
  $font_color: #fff;
  $background-color: #333333;

  header {
    z-index: 999;
    position: fixed;
    height: 60px;
    width: 100%;
    background: rgba($background-color, 0.8);
    opacity: 0;
    animation: slide 1s ease 0.5s 1 forwards;
    top: -60px;
  }
  // main_buttonを下から表示させるアニメーション
  @keyframes slide {
    100% {
      opacity: 1;
      top: 0;
    }
  }
  // navが開いている時
  .open {
    position: relative;
    // ×ボタンを表現
    .hamburger {
      .line:nth-child(1) {
        transform: rotate(45deg) !important;
      }
      .line:nth-child(2) {
        opacity: 0;
      }
      .line:nth-child(3) {
        transform: rotate(-45deg) !important;
      }
    }
    #nav_list {
      transform: translateY(100vh);
    }
  }

  // navの共通設定
  .header_nav {
    position: relative;
    height: 100%;
    .hamburger {
      z-index: 2;
      position: absolute;
      cursor: pointer;
      outline: none !important;
      background: transparent;
      border: none;
      top: 5px;
      right: 20px;
      height: 50px;
      width: 50px;
      .line {
        display: block;
        width: 30px;
        height: 1px;
        background: $font_color;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        transition: all 0.5s ease;
      }
      .line:nth-child(1) {
        transform: translateY(-8px);
      }
      .line:nth-child(3) {
        transform: translateY(8px);
      }
    }

    #nav_list {
      height: 100vh;
      width: 100%;
      background: rgba(#000, 1);
      // background: rgba($background-color, 0.8);
      transition: all 0.5s ease;
      // navが開いていないときに画面外に移動しておく
      position: absolute;
      top: -100vh;
      display: grid;
      grid-template-rows: 20px 60px 1fr 80px;
      grid-template-columns: 100px 50px 1fr;
      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column;
        width: 100%;
        grid-row: 2/4;
        grid-column: 1/4;

        li {
          font-size: $font_size;
          // padding: 10px 11px;
          padding: 5px 11px;
          height: auto;
          a {
            color: $font_color;
            text-decoration: none;
            span {
              // 縦に積む
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
              // 中央寄せ
              justify-content: center;
              align-items: center;
              b {
                border-bottom: 1px solid;
              }
            }
          }
        }
      }
    }
  }

  // headerの画像
  .home_nav_img {
    width: 240px;
    height: 40px;
    // 中央揃え
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 20px;
    bottom: 0;
    #home_nav {
      display: block;
      width: 100%;
      height: 100%;
      background-image: url("../../assets/img/logo.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  #lang_nav {
    position: relative;
    grid-row: 2/3;
    // grid-column: 1/2;
    margin: auto;
    span {
      color: $font_color;
      // 縦に積む
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      // 中央寄せ
      justify-content: center;
      align-items: center;

      p {
        margin: 0;
      }
      div {
        display: flex;
        margin-top: 4px;
        #slash {
          margin: 0 3px;
        }
      }
    }
  }
  #twitter_nav {
    grid-row: 2/3;
    grid-column: 1/3;
    margin-left: 20px;
    // grid-column: 2/3;
    // margin: auto;
    img {
      width: 35px;
      height: 35px;
    }
  }
  .more_nav {
    grid-row: 3/4;
    grid-column: 1/4;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .more_btn {
    color: $font_color;
    position: absolute;
    bottom: 18vh;
    // bottom: 12vh;
    width: 90px;
    height: 40px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: center;
    font-size: 20px;
    left: 0;
    right: 0;
    margin: auto;
    .arrow_down {
      position: relative;
      display: inline-block;
      padding-left: 20px;
      top: 10px;
      &::before {
        content: "";
        width: 20px;
        height: 20px;
        border: 0px;
        border-top: solid 2px $font_color;
        border-right: solid 2px $font_color;
        transform: rotate(135deg);
        position: absolute;
        top: -14px;
        left: 3px;
        right: 0;
        margin-top: -4px;
      }
    }
    .arrow_up {
      position: relative;
      display: inline-block;
      padding-left: 20px;
      top: 10px;
      &::before {
        content: "";
        width: 20px;
        height: 20px;
        border: 0px;
        border-top: solid 2px $font_color;
        border-right: solid 2px $font_color;
        transform: rotate(-45deg);
        position: absolute;
        top: -9px;
        left: 3px;
        right: 0;
        margin-top: -4px;
      }
    }
  }
}

// PC
@media only screen and (min-width: 1024px) {
  $font_size: 12px;
  $font_color: #fff;
  $background-color: #333333;

  header {
    margin-top: 0px;
    height: 55px;
    z-index: 20;
    position: fixed;
    width: 100%;
    opacity: 0;
    animation: slide 1s ease 0.5s 1 forwards;
  }
  // headerを上から表示させるアニメーション
  @keyframes slide {
    100% {
      margin-top: 14px;
      opacity: 1;
    }
  }
  // 共通設定
  .header_nav {
    display: flex;
    align-items: center;
    .hamburger {
      display: none;
    }
    #nav_list {
      height: 55px;
      font-size: $font_size;
      // opacity: 0.8;
      display: flex;
      align-items: center;
      .open_about {
        border-bottom-left-radius: 0 !important;
      }
      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: flex;
        height: 100%;

        li {
          vertical-align: middle;
          background: rgba($background-color, 0.7);
          &:nth-child(1) {
            border-top-left-radius: 24px;
            border-bottom-left-radius: 0px;
          }
          a {
            display: flex;
            color: $font_color;
            text-decoration: none;
            height: 100%;
            padding: 10px 11px;

            span {
              // 縦に積む
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
              // 中央寄せ
              justify-content: center;
              align-items: center;

              b {
                border-bottom: 1px solid;
                white-space: nowrap;
              }
            }
          }
          &:hover,
          &:nth-child(1):hover {
            background: lighten(rgba($background-color, 0.7), 10%);
          }
          &:nth-child(1):hover {
            border-top-left-radius: 24px;
            border-bottom-left-radius: 0px;
          }
        }
      }
    }
  }
  // headerの画像
  .home_nav_img {
    width: 250px;
    height: 55px;
    background: linear-gradient(
      to right,
      rgba($background-color, 0.8) 144px,
      transparent
    );
    margin-right: auto;
    padding-right: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    #home_nav {
      display: block;
      width: 100%;
      height: 40px;
      background-image: url("../../assets/img/logo.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  #lang_nav {
    height: 100%;
    position: relative;
    padding: 6px 10px;
    padding-left: 15px;
    background: rgba($background-color, 0.7);
    &::before {
      content: "";
      position: absolute;
      height: 30px;
      border-left: 1px dashed $font_color;
      left: 1px;
      top: 15px;
    }
    span {
      color: $font_color;
      // 縦に積む
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      // 中央寄せ
      justify-content: center;
      align-items: center;
      height: 100%;
      p {
        margin: 0;
      }
      .lang_title {
        border-bottom: 1px solid;
      }
      div {
        display: flex;
        #slash {
          margin: 0 3px;
        }
      }
    }
  }
  #twitter_nav {
    background: rgba($background-color, 0.7);
    &:hover {
      background: lighten(rgba($background-color, 0.7), 10%) !important;
    }
    img {
      width: 25px;
      height: 25px;
      margin: 15px;
    }
  }
  .more_nav {
    width: 651px;
    height: 55px;
    position: fixed;
    color: $font_color;
    top: 55px;
    //headerと同様にmore_navも14px分下がって降りてくるアニメーション
    animation: slide 1s ease 0.5s 1 forwards;
    ul {
      width: 678px;
      li {
        width: 115px;
        &:nth-child(1) {
          border-top-left-radius: 0px !important;
          border-bottom-left-radius: 24px !important;
        }
        &:nth-child(2) {
          width: 100px;
        }
        &:hover,
        &:nth-child(1):hover {
          background: lighten(rgba($background-color, 0.7), 10%) !important;
        }
        &:nth-child(1):hover {
          border-top-left-radius: 0px !important;
          border-bottom-left-radius: 24px !important;
        }
      }
      .padding {
        width: 463px;
      }
    }
  }

  /*
  PC上でのみ(widthが1024以上の時)navを全て表示にするためmoreボタンのcssをコメントアウト
  */

  /*.more_btn {
    background: rgba($background-color, 0.7);
    color: $font_color;
    position: fixed;
    right: 300px;
    top: 69px;
    width: 90px;
    height: 23px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
    &:hover {
      background: lighten(rgba($background-color, 0.7), 10%);
    }
    .arrow_down {
      position: relative;
      display: inline-block;
      padding-left: 20px;
      &::before {
        content: "";
        width: 10px;
        height: 10px;
        border: 0px;
        border-top: solid 2px $font_color;
        border-right: solid 2px $font_color;
        transform: rotate(135deg);
        position: absolute;
        top: -14px;
        left: 3px;
        right: 0;
        margin-top: -4px;
      }
    }
    .arrow_up {
      position: relative;
      display: inline-block;
      padding-left: 20px;
      &::before {
        content: "";
        width: 10px;
        height: 10px;
        border: 0px;
        border-top: solid 2px $font_color;
        border-right: solid 2px $font_color;
        transform: rotate(-45deg);
        position: absolute;
        top: -9px;
        left: 3px;
        right: 0;
        margin-top: -4px;
      }
    }
  }
  .open_more_btn {
    top: 124px;
  }
  */
}
</style>
